/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Additionalstudyinterests_Study_Koreastudies19Inputs */

const en__field__enum_additionalstudyinterests_study_koreastudies19 = /** @type {(inputs: _Field__Enum_Additionalstudyinterests_Study_Koreastudies19Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Korea Studies`)
};

const de__field__enum_additionalstudyinterests_study_koreastudies19 = /** @type {(inputs: _Field__Enum_Additionalstudyinterests_Study_Koreastudies19Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koreastudien`)
};

/**
* | output |
* | --- |
* | "Korea Studies" |
*
* @param {_Field__Enum_Additionalstudyinterests_Study_Koreastudies19Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_additionalstudyinterests_study_koreastudies19 = /** @type {((inputs?: _Field__Enum_Additionalstudyinterests_Study_Koreastudies19Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Additionalstudyinterests_Study_Koreastudies19Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_additionalstudyinterests_study_koreastudies19(inputs)
	return de__field__enum_additionalstudyinterests_study_koreastudies19(inputs)
});
export { _field__enum_additionalstudyinterests_study_koreastudies19 as "_field__enum_additionalStudyInterests_STUDY_KOREASTUDIES" }